import Icon from '#base/ui/Icon.js';
import classNames from 'classnames';
import React, { memo } from 'react';
import { FaChevronRight } from 'react-icons/fa';

interface IProps {
  text: string;
  subtext?: string | React.ReactNode;
  iconUrl: string;
  onClick: any;
  disabled: boolean;
  mode?: 'vertical' | 'horizontal' | 'grid';
  className?: string;
}

const DesignOption = ({
  text,
  subtext,
  iconUrl,
  onClick,
  disabled = false,
  mode = 'horizontal',
  className = '',
}: IProps) => {
  return (
    <div
      className={classNames(
        't-flex t-cursor-pointer t-items-center t-transition t-duration-300 hover:t-bg-neutral-100',
        {
          't-opacity-50': disabled,
        },
        {
          't-justify-between t-rounded-xl t-border t-border-neutrals-light-grey t-bg-white t-px-5 t-py-3 last:t-mb-0':
            mode === 'horizontal',
          't-w-1/5 t-justify-center t-p-1': mode === 'vertical',
          't-h-[100px] t-w-[100px] t-justify-center t-rounded-xl t-border t-border-neutrals-light-grey':
            mode === 'grid',
        },
        className
      )}
      onClick={(...e) => !disabled && onClick(...e)}>
      <div
        className={classNames('t-flex t-items-center', {
          't-flex-col t-justify-center t-gap-2': mode === 'vertical' || mode === 'grid',
          't-gap-5': mode === 'horizontal',
        })}>
        {iconUrl && (
          <Icon
            url={iconUrl}
            color='var(--plum-brand-black)'
            size={mode === 'vertical' ? 23 : mode === 'horizontal' ? 30 : 40}
          />
        )}
        <span
          className={classNames('t-text-brand-black', {
            't-text-sm t-font-bold': mode === 'horizontal',
            't-text-center t-text-xs t-font-semibold': mode === 'vertical' || mode === 'grid',
          })}>
          {text}
        </span>
        {mode !== 'vertical' && subtext && (
          <span
            className={classNames('t-font-normal t-text-muted', {
              't-text-sm': mode === 'horizontal',
              't-text-center t-text-xs': mode === 'grid',
            })}>
            {subtext}
          </span>
        )}
      </div>
      {mode === 'horizontal' && <FaChevronRight color='var(--plum-brand-black)' size={14} />}
    </div>
  );
};

export default memo(DesignOption);
